import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=4c693999&"
import script from "./forbidden.vue?vue&type=script&lang=ts&"
export * from "./forbidden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports